export default __webpack_public_path__ + "static/media/3mm 1.af6b16e6.jpg";